<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form :form="form" layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="要货单号" :help="null">
              <global-select
                v-decorator="['deliveryNotice']"
                selectType="selectSearch"
                requestApi="/po/poDeliveryNoticeLines/deliveryNoticeBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                searchParam="deliveryNotice"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="组织">
              <global-select
                v-decorator="['organizationCode', { initialValue: organizationCodeOrigin }]"
                requestApi="/system/user/inventOrg"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="供应商">
              <global-select
                v-decorator="['supplierCodeList']"
                selectType="selectMultipleSearch"
                requestApi="/mdm/mdmOrgSupplier/supplierBox"
                :selectItem="{ value: 'bringOutDataOne', label: 'label' }"
                searchParam="supplierName"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="状态">
              <global-select
                v-decorator="['statusList']"
                selectType="selectMultiple"
                :selectData="lineTypeListData"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="物料编码">
              <global-select
                v-decorator="['itemCodeList']"
                selectType="selectMultipleSearch"
                :dropdown-match-select-width="false"
                requestApi="/mdm/mdmItemOrganizationItem/itemCodeOneBox"
                :selectItem="{ value: 'label', label: 'label' }"
                :setParams="{ organizationCode: form.getFieldsValue().organizationCode || organizationCodeOrigin }"
                :focusGet="true"
                searchParam="itemCode"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="创建日期">
              <a-range-picker
                v-decorator="['createDateRange']"
                valueFormat="YYYY-MM-DD"
                allowClear
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="物料名称">
              <a-input v-decorator="['itemName']" allowClear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="采购订单" :help="null">
              <global-select
                v-decorator="['poNo']"
                selectType="selectSearch"
                requestApi="/po/poDeliveryNoticeLines/poNoBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                searchParam="poNo"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="创建人" :help="null">
              <global-select
                v-decorator="['createName']"
                selectType="selectSearch"
                requestApi="/po/poDeliveryNoticeLines/createNameBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                searchParam="createName"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="发货单">
              <a-input v-decorator="['doNo']" allowClear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="批次号">
              <a-input v-decorator="['lotNo']" allowClear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="一级分类" :help="null">
              <global-select
                v-decorator="['name1']"
                selectType="selectSearch"
                requestApi="/po/poDeliveryNoticeLines/firstLevelBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                searchParam="name1"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <div class="table-page-operator-wrapper mt5 mb10">
          <a-button :loading="btnLoading" type="primary" @click="$refs.forGoodsManageAdd.show()" v-hasPermi="['po:poDeliveryNoticeLines:add']">新建</a-button>
          <a-button :loading="btnLoading" @click="handleExport" v-hasPermi="['po:poDeliveryNoticeLines:export']">导出</a-button>
          <!-- <a-button :disabled="selectedRows.length === 0" @click="handleClose" v-hasPermi="['po:poDeliveryNoticeLines:close']">关闭</a-button> -->
          <a-button :loading="btnLoading" @click="onCancel" v-hasPermi="['po:poDeliveryNoticeLines:close']">取消</a-button>
          <download-modal :apiFun="apiV2Export" ref="download" />
          <a-button :loading="btnLoading" type="primary" :disabled="selectedRows.length===0" @click="onExamine">审核</a-button>
          <a-button :loading="btnLoading" type="primary" :disabled="selectedRows.length===0" @click="onReject">驳回</a-button>
          <a-button :loading="btnLoading" type="primary" :disabled="selectedRows.length===0" @click="onClose">关闭</a-button>
        </div>
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :selectedRows.sync="selectedRows"
          rowKey="id"
          :customSelection="{keepSelect: true}"
          :scroll="{ x: tableX, fixScreen: true }"
          @selectedRowChange="selectedRowChange"
          @change="handleTableChange"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.FOR_GOODS_MANAGE_LIST, // 表格方案配置唯一值
              }"
        >
          <template slot="date" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD') }}</span>
          </template>
          <!--计划到货日期，待确认,已确认且要有权限才可编辑-->
          <template slot="planDate" slot-scope="text">
            <a-date-picker
              style="min-width: 165px;"
              v-model="text.record.planDate"
              format="YYYY-MM-DD HH:mm:ss"
              :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
              :disabled-date="disabledDate"
              v-if="permissionList.includes('PLANNED_ARRIVAL_DATE')&&['APPROVED', 'PENDING_RESPONSE'].includes(text.record.status)"
              @openChange="(status) => onOpenDateChange(status , text.record, 'planDate')"
              @ok="(val) => onOk(val, text.record, 'planDate')"
            />
            <span v-else>{{ text.record.planDate }}</span>
          </template>
        <!--材料商确认日期，（状态待确认或已确认，且已送货量为0）或审批中，且有权限才可编辑-->
          <template slot="confirmedDate" slot-scope="text">
            <a-date-picker
              style="min-width: 165px;"
              v-model="text.record.confirmedDate"
              format="YYYY-MM-DD HH:mm:ss"
              :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
              :disabled-date="disabledDate"
              v-if="permissionList.includes('CONFIRMATION_DATE')&&((['APPROVED', 'PENDING_RESPONSE'].includes(text.record.status)&&text.record.quantityShipped===0)||text.record.status==='IN_APPROVAL')"
              @openChange="(status) => onOpenDateChange(status , text.record, 'confirmedDate')"
              @ok="(val) => onOk(val, text.record, 'confirmedDate')"
            />
            <span v-else>{{ text.record.confirmedDate }}</span>
          </template>
          <!--说明字段，已确认、待确认状态且要有权限才可编辑-->
          <template slot="comments" slot-scope="text">
            <a-input
              type="textarea" :autoSize="{minRows:2}"
              v-model="text.record.comments"
              v-if="permissionList.includes('DESCRIPTION')&&['PENDING_RESPONSE', 'APPROVED'].includes(text.record.status)"
              @focus="onCommentsFocus(text.record.comments)"
              @blur="onCommentsBlur(text.record)" />
            <span v-else>{{ text.record.comments }}</span>
          </template>
          <!-- 操作,拆分按钮待确认、已确认允许点击 -->
          <span slot="operation" slot-scope="{ record }">
            <a @click="$refs.forGoodsManageSplit.show(record)" :disabled="!['PENDING_RESPONSE', 'APPROVED'].includes(record.status)" v-hasPermi="['po:poDeliveryNoticeLines:split']">拆分</a>
            <a class="ml8" @click="handleLog(record)">日志</a>
          </span>
        </ls-api-table>
        <for-goods-manage-add ref="forGoodsManageAdd" :inventOrg="inventOrg" @handle-success="handleOk" />
        <for-goods-manage-split ref="forGoodsManageSplit" @handle-success="handleOk2" />
        <a-modal
          :visible="isShowCloseReasonInputDialog"
          title="关闭原因"
          :confirm-loading="isConfirmCloseBtnLading"
          @ok="handleConfirmClose"
          @cancel="handleCancelClose"
        >
          <a-textarea placeholder="请输入关闭原因" v-model="closeReason" :auto-size="{ minRows: 4, maxRows: 6 }" />
        </a-modal>
        <cancel-modal ref="cancelModalRef" @closeCancel="closeCancel" />
        <operation-log-model ref="operationLogModelRef" :logLoading="logLoading" :logList="logList" @closeLog="closeLogFun" />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import {
  apiPoDeliveryNoticeLinesList,
  apiItemCategoryCodeCategoryBox,
  apiPoDeliveryNoticeLinesClose,
  apiV2Export,
  apiListDeliveryLog,
  apiPoDeliveryNoticeLinesRejected,
  apiPoDeliveryNoticeLinesAudit,
  apiCloseNoChangeAll,
  apiPoDeliveryNoticeLinesUpdate,
  apiPoGetPoPermissions
} from '@/api/scp/reserve-goods-plan/for-goods-manage'
import { generateLsTableResData } from '@/utils/util.js';
import ForGoodsManageAdd from './components/for-goods-manage-add'
import ForGoodsManageSplit from './components/for-goods-manage-split'
import cancelModal from "./components/cancel-modal"
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import deepClone from "lodash.clonedeep";
import moment from 'moment';
import OperationLogModel from '@/components/operation-log/operation-log-model.vue'

export default {
  // eslint-disable-next-line
  name: 'For-goods-manage', // name要和rms配置菜单路由保存一致(首字母大写)
  components: {
    ForGoodsManageAdd,
    ForGoodsManageSplit,
    cancelModal,
    DownloadModal,
    OperationLogModel
  },
  data () {
    return {
      apiV2Export,
      isEdit: false,
      logLoading: false, // 日志loading
      logList: [], // 日志列表
      permissionList: [], // 权限字段。["PLANNED_ARRIVAL_DATE计划到货日期", "CONFIRMATION_DATE材料商确认日期", "DESCRIPTION说明"]
      tempDateTime: '', // 临时记录日期数据
      temporaryComments: '', // 临时记录说明字段
      currentId: "",
      tableProps: {
        requestApi: generateLsTableResData(apiPoDeliveryNoticeLinesList, true),
        pageCurrent: true
      },
      // 查询参数
      form: this.$form.createForm(this),
      // 控制搜索展开
      advanced: true,
      // 表格数据
      tableX: 2750,
      tableList: [],
      // 表格字段
      columns: [
        { title: '组织', dataIndex: 'organizationName', align: 'center', width: 120, fixed: 'left' },
        { title: '主体', dataIndex: 'mainBody', align: 'center', width: 100, fixed: 'left' },
        { title: '采购订单号', dataIndex: 'poNo', width: 120, align: 'center', fixed: 'left' },
        { title: '要货单号', dataIndex: 'deliveryNotice', align: 'center', width: 120, fixed: 'left' },
        { title: '物料编码', dataIndex: 'itemCode', align: 'center', width: 120, fixed: 'left' },
        { title: '单位', dataIndex: 'uom', align: 'center', width: 120, fixed: 'left' },
        { title: '状态', dataIndex: 'statusName', width: 120, align: 'center', fixed: 'left' },
        { title: '物料名称', dataIndex: 'itemName', align: 'center', width: 150, ellipsis: true },
        { title: '规格描述', dataIndex: 'specification', align: 'center', width: 150, ellipsis: true },
        { title: '供应商', dataIndex: 'supplierName', width: 120, align: 'center' },
        { title: '要求到货日期', dataIndex: 'needByDate', align: 'center', scopedSlots: { customRender: 'date' }, width: 120, type: "text" },
        { title: '计划到货日期', dataIndex: 'planDate', scopedSlots: { customRender: 'planDate' }, width: 185, align: 'center' },
        { title: '需求数量', dataIndex: 'quantity', width: 120, align: 'center' },
        {
          title: '材料商确认日期',
          dataIndex: 'confirmedDate',
          sorter: true,
          scopedSlots: { customRender: 'confirmedDate' },
          align: 'center',
          width: 185,
          type: 'confirmedDate'
        },
        { title: '双方确认数量', dataIndex: 'confirmedQuantity', width: 150, align: 'center' },
        { title: '考核日期', dataIndex: 'assessmentDate', width: 150, align: 'center' },
        { title: '安排中数量', dataIndex: 'quantityScheduled', width: 100, align: 'center' },
        { title: '待送货量', dataIndex: 'quantityPendingShipment', width: 100, align: 'center' },
        { title: '已送货量', dataIndex: 'quantityShipped', width: 100, align: 'center' },
        { title: '已接收量', dataIndex: 'quantityDelivered', width: 100, align: 'center' },
        { title: '收货差额', dataIndex: 'quantityRcvTolerance', width: 100, align: 'center' },
        { title: '在途数量', dataIndex: 'quantityInTransit', width: 100, align: 'center' },
        { title: '可取消数量', dataIndex: 'cancellableQuantity', width: 100, align: 'center' },
        { title: '已取消数量', dataIndex: 'canceledQuantity', width: 100, align: 'center' },
        { title: '来源', dataIndex: 'sourceCodeName', width: 120, align: 'center' },
        { title: '备料日期', dataIndex: 'suggestOrderDate', width: 120, align: 'center' },
        { title: '下达日期', dataIndex: 'dateReleased', align: 'center', scopedSlots: { customRender: 'date' }, width: 120, type: "text" },
        { title: '目的仓', dataIndex: 'subinventory', width: 120, align: 'center' },
        { title: '取消原因', dataIndex: 'closeReason', width: 120, align: 'center' },
        { title: '实际送货时间', dataIndex: 'actualDelivery', width: 140, align: 'center' },
        { title: '接收时间', dataIndex: 'receiptDate', width: 140, align: 'center' },
        { title: '说明', dataIndex: 'comments', scopedSlots: { customRender: 'comments' }, width: 260, align: 'center' },
        { title: '发货单', dataIndex: 'doNo', width: 100, align: 'center' },
        { title: '批次号', dataIndex: 'lotNo', width: 100, align: 'center' },
        { title: '创建人', dataIndex: 'createName', width: 90, align: 'center' },
        { title: '创建时间', dataIndex: 'createTime', width: 140, align: 'center' },
        { title: '一级分类', dataIndex: 'name1', width: 90, align: 'center' },
        { title: '操作', width: 100, dataIndex: 'operation', scopedSlots: { customRender: 'operation' }, fixed: 'right' }
      ],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      treeData: [], // 物料类别
      lineTypeListData: [], // 状态
      btnLoading: false,
      isShowCloseReasonInputDialog: false,
      closeReason: '',
      isConfirmCloseBtnLading: false
    }
  },
  computed: {
    ...mapState({
      jobCode: (state) => state.user.jobCode, // 登录人工号
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode,
      cashHistory: (state) => state.pageHistory.cashHistory
    })
  },
  created () {
    this.btnLoading = false
    // this.getLookupList('PO_DELIVERY_NOTICE_STATUS', 'lineTypeListData')
    this.getSearchAllScheme()
    // 缓存处理逻辑
    if (this.cashHistory && this.cashHistory[this.$route?.fullPath]) {
      const cashParam = this.cashHistory[this.$route?.fullPath]
      // 特殊处理状态的初始化
      this.getLookupList('PO_DELIVERY_NOTICE_STATUS', 'lineTypeListData', 'notInit')
      this.$nextTick(() => {
        this.form.setFieldsValue({ ...cashParam })
      })
    } else {
      this.getLookupList('PO_DELIVERY_NOTICE_STATUS', 'lineTypeListData')
    }
    this.getPermission()
  },
  mounted () {},
  methods: {
    moment,
    // 获取快码配置的权限，用于判断"PLANNED_ARRIVAL_DATE计划到货日期", "CONFIRMATION_DATE材料商确认日期", "DESCRIPTION说明"三个字段是否有权限编辑
    getPermission () {
      this.permissionList = []
      apiPoGetPoPermissions({ userId: this.jobCode }).then(res => {
        if (res?.length > 0) { this.permissionList = res }
      })
    },
    // 控制只能选今天后的日期
    disabledDate (date) {
      return date && date.valueOf() < Date.now();
    },
    // 关闭日志弹窗
    closeLogFun() {
      this.logLoading = false;
      this.logList = [];
    },
    // table排序等
    handleTableChange (pagination, filters, sorter, { currentDataSource }) {
      let obj = {}
      const params = this.$refs.dataTable.searchParams
      if(sorter?.order && sorter?.columnKey) {
        obj = {
          orderColumn: sorter.columnKey,
          sortFlag: sorter.order === "ascend" ? 'asc' : 'desc'
        }
        this.$refs.dataTable.searchParams = deepClone({ ...params, ...obj });
      } else {
        if (params?.orderColumn) {
          delete params.orderColumn
          delete params.sortFlag
          this.$refs.dataTable.searchParams = params
        }
      }
    },
    // 操作日志弹窗
    handleLog(row) {
      this.logList = []
      this.logLoading = true
      this.$refs.operationLogModelRef.show()
      apiListDeliveryLog({ drNo: row.drNo }).then(res => {
        if (res.code === 200) {
          if (res?.data?.length > 0) { this.logList = res.data }
        }
      }).finally(() => {
        this.logLoading = false
      })
    },
    // 说明字段变化记录
    onCommentsBlur(row) {
      if(this.temporaryComments !== row.comments) {
        this.$message.loading('更新中', 0.5)
        apiPoDeliveryNoticeLinesUpdate({ id: row.id, comments: row.comments }).then(res => {
          if (res.code === 200) {
            this.$message.success('修改成功！')
          } else {
            this.$message.error(res.msg)
          }
        }).finally(() => {
          this.onSearch(true) // 不管是否成功都重新查询
        })
      }
    },
    // 说明字段输入框获取焦点
    onCommentsFocus(comments) {
      this.temporaryComments = comments
    },
    // 确认交期保存
    onOk(date, row, field) {
      if (!date) { return false }
      const params = { id: row.id }
      row[field] = this.$moment(date).format('YYYY-MM-DD HH:mm:ss')
      params[field] = row[field]
      this.$message.loading('更新中', 0.5)
      apiPoDeliveryNoticeLinesUpdate(params).then(res => {
        if (res?.code === 200) {
          this.$message.success('修改成功！')
        } else {
          this.$message.error(res?.msg)
        }
      }).finally(() => {
        this.onSearch(true) // 不管是否成功都重新查询
      })
    },
    // 确认交期选择关闭提示, status: true 打开弹窗，false 关闭弹窗
    onOpenDateChange(status, row, field) {
      if (status) {
        this.tempDateTime = this.$moment(row[field]).format('YYYY-MM-DD HH:mm:ss') || '' // 打开日期弹窗，先记录历史日期
      } else {
        if (row[field]) {
          const newDate = this.$moment(row[field]).format('YYYY-MM-DD HH:mm:ss')
          if (newDate !== this.tempDateTime) {
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1); // 设置为明天的日期
            tomorrow.setHours(0, 0, 0, 0); // 设置时分秒和毫秒为0
            if (new Date(newDate).getTime() < tomorrow.getTime()) {
              this.$message.warning('只能选择今天之后的日期！')
              row[field] = this.tempDateTime
            }
          }
        }
      }
    },
    // 关闭取消弹窗后查询数据
    closeCancel(isUpdate) {
      if (isUpdate) {
        if (this.$refs?.dataTable) this.$refs.dataTable.onClear(); // 清除选择
        this.onSearch(false);
      } else {
        // this.onSearch(true);
      }
    },
    // 审核
    onExamine() {
      const getData = this.selectedRows.find(item => item.status !== 'IN_APPROVAL')
      if(getData) {
        this.$message.warning('请勾选审批中单据审核')
        return
      }
      this.confirmRequest('审核', apiPoDeliveryNoticeLinesAudit);
    },
    // 驳回
    onReject() {
      const getData = this.selectedRows.find(item => item.status !== 'IN_APPROVAL')
      if(getData) {
        this.$message.warning('请勾选审批中单据驳回')
        return
      }
      this.confirmRequest('驳回', apiPoDeliveryNoticeLinesRejected);
    },
    // 关闭
    onClose() {
      const getData = this.selectedRows.find(item => item.status !== 'PENDING_RESPONSE')
      if(getData) {
        this.$message.warning('请勾选待确认单据关闭')
        return
      }
      this.confirmRequest('关闭', apiCloseNoChangeAll);
    },
    // 公共确认请求
    confirmRequest(tip, apiFun) {
      this.$confirm({
        title: '提示',
        content: `确定${tip}勾选单据吗？`,
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          this.pubRequest(apiFun)
        }
      })
    },
    // 公共请求
    pubRequest(apiFun) {
      this.btnLoading = true
      apiFun(this.selectedRows.map(item => item.id)).then(res => {
        if (res.code === 200) {
          this.$message.success(res?.data || '操作成功')
          this.onSearch()
        }
      }).finally(() => {
        this.btnLoading = false
      })
    },
    // 打开取消弹窗
    onCancel() {
      if (this.selectedRows?.length < 1) {
        this.$message.warning('请勾选数据！')
        return
      }
      this.$refs.cancelModalRef.show(this.selectedRows);
    },
    // 关闭
    handleClose () {
      this.isShowCloseReasonInputDialog = true
    },
    handleOk (data) {
      this.form.setFieldsValue({
        deliveryNotice: data
      })
      this.onSearch()
    },
    handleOk2 () {
      this.onSearch()
    },
    // 表单搜索
    onSearch (changePage) {
      this.isEdit = false
      if (this.$refs?.dataTable) this.$refs.dataTable.onClear(); // 清除选择
      const tempDateFrom = this.form && this.form.getFieldValue('createDateRange') && this.form.getFieldValue('createDateRange')[0] || ""
      const tempDateTo = this.form && this.form.getFieldValue('createDateRange') && this.form.getFieldValue('createDateRange')[1] || ""
      const searchParams = this.form.getFieldsValue();
      this.$store.commit('setCashHistory', { path: this.$route.fullPath, data: deepClone(searchParams) })
      this.$refs.dataTable.searchParams = {
        ...this.form.getFieldsValue(),
        stareCreateDate: tempDateFrom,
        endCreateDate: tempDateTo
      };
      this.$refs.dataTable.getData(changePage === true);
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.form.resetFields()
      this.tableList = []
      this.onSearch()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 导出按钮操作 */
    handleExport () {
      const tempDateFrom = this.form && this.form.getFieldValue('createDateRange') && this.form.getFieldValue('createDateRange')[0] || ""
      const tempDateTo = this.form && this.form.getFieldValue('createDateRange') && this.form.getFieldValue('createDateRange')[1] || ""
      const params = {
        ...this.form.getFieldsValue(),
        stareCreateDate: tempDateFrom,
        endCreateDate: tempDateTo
      };
      this.$refs.download.openModal(params)
      /* this.download('po/poDeliveryNoticeLines/v2/export', {
        ...params
      }, `要货单管理_${new Date().getTime()}.xlsx`) */
    },
    // 物料类别-下拉框数据
    getSearchAllScheme () {
      apiItemCategoryCodeCategoryBox({ parameterCode: "SCP_ITEM_CATEGORY", parameterLevelCode: "GLOBAL" }).then(res => {
        if (res.data && res.data.length > 0) {
          this.treeData = res.data
        }
      })
    },
    /** 行选中 */
    selectedRowChange (selectedRowKeys, selectedRows) {
      console.log(this.selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    getLookupList (type, arr, isInit) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        if (type === "PO_DELIVERY_NOTICE_STATUS") {
          const arr2 = []
          response.rows.forEach(element => {
            if (element.attribute1 === "Y") {
              arr2.push(element.lookupCode)
            }
          });
          // 用缓存就不初始化
          if (isInit !== 'notInit') {
            this.form.setFieldsValue({
              statusList: arr2
            })
          }
        }
        this[arr] = response.rows
      })
    },
    handleConfirmClose () {
      // this.isShowCloseReasonInputDialog = false
      // this.closeReason = ''
      this.isConfirmCloseBtnLading = true
      apiPoDeliveryNoticeLinesClose({ ids: this.selectedRows.map(item => item.id), closeReason: this.closeReason }).then(res => {
        if (res.code === 200) {
            this.$message.success('关闭成功')
            this.isShowCloseReasonInputDialog = false
            this.closeReason = ''
            this.onSearch()
        } else {
            this.$message.error(res.msg)
        }
      }).finally(() => {
        this.isConfirmCloseBtnLading = false
      })
    },
    handleCancelClose () {
      this.isShowCloseReasonInputDialog = false
      this.closeReason = ''
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-select-selection__choice{
  width: 66.47px;
}
.color-2ea1ff{
  color: #2ea1ff !important;
}
</style>
